import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "content",
  style: {"padding":"20px 0"}
}

import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import CommonDialog from '@/components/common/CommonDialog.vue'
import TaxTable from '@/components/tax/TaxTable.vue'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'defaultSelection'],
  emits: ['update:visible', 'updateSel'],
  setup(__props, { emit }) {

const props = __props



const cancel = () => {
  emit('update:visible', false)
}
const formRef = ref()
const selected: any = ref([])
const updateSel = (val:any) => {
  if (val) {
    selected.value = [val]
  } else {
    selected.value = []
  }
}
const commit = () => {
  if (!selected.value.length) {
    ElMessage.warning(t('请选择账号'))
    return false
  }
  emit('updateSel', selected.value)
  emit('update:visible', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonDialog, {
    visible: __props.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    onOk: commit,
    onCancel: cancel,
    title: _unref(t)('请选择账号'),
    footer: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TaxTable, {
          defaultSelection: props.defaultSelection,
          onUpdateSel: updateSel
        }, null, 8, ["defaultSelection"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})